module.exports = __webpack_public_path__ + "static/img/logo.dd63a303.png";